import { v as v1_1 } from './v1.js';
import { v as v4_1 } from './v4.js';

var v1 = v1_1;
var v4 = v4_1;

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

var uuid_1 = uuid;

export { uuid_1 as u };
//# sourceMappingURL=index.js.map
